"use client";

import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from "react";
import { CookiesProvider } from "react-cookie";
import { Provider as JotaiProvider, createStore } from "jotai";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
// import { SerwistProvider } from "@serwist/next/react";

// import { AbstractIntlMessages, NextIntlClientProvider } from "next-intl";

import { Popup } from "~/client/components/portals/Popup";
import { type DeviceProps, DeviceContext as DeviceProvider
// useOfflineSync,
// useServiceWorkerRegistration,
} from "~/client/hooks/useDevice";
import { GlobalStyles } from "~/client/styles/GlobalStyles";
import { getQueryClient } from "~/shared/services/config/getQueryClient";
const store = createStore();
interface ProviderProps {
  readonly device: DeviceProps;
  // readonly locale: string;
  // readonly messages: AbstractIntlMessages;
}
export const ClientLayout = t0 => {
  const $ = _c(9);
  const {
    children,
    device
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getQueryClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <GlobalStyles />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Popup />;
    t4 = <ReactQueryDevtools />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== children) {
    t5 = <QueryClientProvider client={queryClient}>{t2}{children}{t3}{t4}</QueryClientProvider>;
    $[4] = children;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== device || $[7] !== t5) {
    t6 = <CookiesProvider><PostHogProvider client={posthog}><JotaiProvider store={store}><DeviceProvider value={device}>{t5}</DeviceProvider></JotaiProvider></PostHogProvider></CookiesProvider>;
    $[6] = device;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};